import { Typography, Stack } from '@mui/material';
import { Loader, StepPanel } from 'src/components';

export const PendingResults: React.FC = () => {
  return (
    <StepPanel
      data-testid="auth-user-confirmation"
      maxWidth="34.25rem"
      gap="1.5rem"
    >
      <Stack>
        <Typography variant="body1" fontSize="72px">
          ⏳
        </Typography>
        <Typography variant="h2" mb={0}>
          Evaluating results
        </Typography>
      </Stack>
      <Typography variant="body1" fontWeight={600}>
        Thanks for your patience!
      </Typography>
      <Loader position="auto" />
      <Typography variant="body1" color="text.secondary">
        Please hang on, it may take some time.
      </Typography>
    </StepPanel>
  );
};
